import React, { useState, useCallback } from "react";

import PageContent from "components/PageContent";
import ContactForm from "components/ContactForm";
import ModalFieldSelect from "components/ModalFieldSelect";
import { usePageTitlePrefix } from "hooks/usePageTitlePrefix";
import terminology from "terminology.json";

import interestImage from "resources/interest.jpg";

const PageInterest: React.FunctionComponent = () => {
	usePageTitlePrefix("Register Interest");

	const [interestedIn, setInterestedIn] = useState<string[]>([]);

	const resetInterestedIn = useCallback(() => {
		setInterestedIn([]);
	}, [setInterestedIn]);

	return (
		<PageContent>
			<header className="major">
				<h1>Register Interest</h1>
			</header>

			<span className="image main">
				<img src={interestImage} alt="Postbox" />
			</span>

			<p>
				Thank you for your interest in Aldeia. Please fill out your details
				below, and expect a reply very soon (the only required field is email -
				all other fields optional).
			</p>

			<ContactForm
				onSubmit={resetInterestedIn}
				onReset={resetInterestedIn}
				messagePlaceholder="Do you have any questions to ask or comments to make?"
				enquiryType="Register-interest form enquiry"
			>
				<div className="col-12">
					<input
						type="hidden"
						name="interestedin"
						value={interestedIn.join(", ")}
					/>

					<ModalFieldSelect
						onOK={newOptions => {
							setInterestedIn(
								newOptions
									.filter(opt => opt.selected)
									.map(opt => opt.value + "")
							);
						}}
						title="Interest in Aldeia"
						options={[
							"Being a " + terminology.mentor,
							"Being a student",
							"Job opportunities (please specify what type)",
							"Other"
						].map(opt => {
							const value = opt.toLowerCase();
							return {
								id: value,
								value,
								text: opt,
								selected: interestedIn.includes(value)
							};
						})}
						allowMultipleSelections
						allowWrapTextInButton={false}
						useTallButton
						useTertiaryButton
					/>
				</div>
			</ContactForm>
		</PageContent>
	);
};

export default PageInterest;
